import { Navigate } from "react-router";
import { useAppSelector } from "../store";
import Login from "./Login";
import { UserRole } from "lib/types";

const HomeAuth = () => {
  const myRole = useAppSelector((state) => state.user.role);

  if (
    myRole === UserRole.USER ||
    myRole === UserRole.MANAGER ||
    myRole === UserRole.ADMIN
  )
    return <Navigate to="/school" />;
  else return <Login />;
};

export default HomeAuth;
